import { observer } from "mobx-react-lite"

import { Button } from "@/components/button"
import { DisplayTokenRow } from "@/domains/common/components/display-token-row"
import { cn } from "@/domains/library"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { DisplayMinimalPool } from "@/domains/minimal-pool/components/display-minimal-pool"
import { showDisplayType } from "@/lib/show-display-type"

export const StoreMobileFeesView = observer(
  ({ pools, onClaimLpFees }: { pools: Array<MinimalPoolStore>; onClaimLpFees: (pool: MinimalPoolStore) => void }) => {
    return (
      <div className="overflow-hidden rounded-t-xl border border-p400-light ">
        <div className={cn("bg-p400 px-4 text-t200", "items-center justify-between gap-2 py-2 pr-8 text-sm")}>
          Pool / Earned
        </div>

        {pools.map((pool) => {
          return (
            <div
              key={pool.address.toString()}
              className={cn("flex flex-col gap-2 border-b border-p400-light bg-p400 px-4 py-4 text-sm text-t200")}
            >
              <div className="flex items-start">
                <DisplayMinimalPool
                  pool={pool}
                  label={showDisplayType(pool.displayType, true, true)}
                  className="flex-row items-start"
                />
              </div>

              <div className="flex flex-row items-center justify-between">
                <div className="flex flex-col items-start justify-center gap-1 text-xs">
                  <DisplayTokenRow token={pool.token0} amount={pool.onChainUserClaimableFees0} />
                  <DisplayTokenRow token={pool.token1} amount={pool.onChainUserClaimableFees1} />
                </div>
                <div className="">
                  <Button
                    title="Claim fees"
                    onClick={() => {
                      void onClaimLpFees(pool)
                    }}
                    variant="percentage"
                  >
                    Claim
                  </Button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  },
)
